/** @format */

import {
  ADD_TEACHER_SUBJECT,
  ADD_CLASS_SECTION,
  FILTER_TEACHERS,
  DELETE_DATA,
  EDIT_TEACHERS_DATA,
  CHANGE_PAGE_NO,
  CREATE_PAGES
} from "../action/actionTypes";

const initialState = {
  classes: [
    {
      std: "Class 1",
      sections: ["A", "B"]
    },
    {
      std: "Class 2",
      sections: ["A", "B", "C"]
    },
    {
      std: "Class 3",
      sections: ["A"]
    },
    {
      std: "Class 4",
      sections: ["A", "B"]
    },
    {
      std: "Class 5",
      sections: ["A", "B"]
    },
    {
      std: "Class 6",
      sections: ["A", "B"]
    },
    {
      std: "Class 7",
      sections: ["A", "B"]
    },
    {
      std: "Class 8",
      sections: ["A", "B"]
    },
    {
      std: "Class 9",
      sections: ["A", "B"]
    },
    {
      std: "Class 10",
      sections: ["A", "B"]
    }
  ],
  teachers: [
    {
      id: 1,
      teacherName: "Arun",
      subjectName: "Maths",
      sectionSelected: "A",
      classSelected: "Class 1"
    },
    {
      id: 2,
      teacherName: "Vinay",
      subjectName: "English",
      sectionSelected: "B",
      classSelected: "Class 1"
    },
    {
      id: 3,
      teacherName: "Nrupul",
      subjectName: "English",
      sectionSelected: "B",
      classSelected: "Class 2"
    },
    {
      id: 4,
      teacherName: "Albert",
      subjectName: "Science",
      sectionSelected: "A",
      classSelected: "Class 2"
    },
    {
      id: 5,
      teacherName: "Abhinay",
      subjectName: "Maths",
      sectionSelected: "B",
      classSelected: "Class 3"
    },
    {
      id: 6,
      teacherName: "Rehan",
      subjectName: "English",
      sectionSelected: "A",
      classSelected: "Class 4"
    },
    {
      id: 7,
      teacherName: "Arun",
      subjectName: "Science",
      sectionSelected: "B",
      classSelected: "Class 4"
    },
    {
      id: 8,
      teacherName: "Abhishek",
      subjectName: "English",
      sectionSelected: "A",
      classSelected: "Class 5"
    },
    {
      id: 9,
      teacherName: "Rakesh",
      subjectName: "Science",
      sectionSelected: "A",
      classSelected: "Class 5"
    },
    {
      id: 10,
      teacherName: "Aman",
      subjectName: "Science",
      sectionSelected: "B",
      classSelected: "Class 5"
    },
    {
      id: 11,
      teacherName: "Divyansh",
      subjectName: "Maths",
      sectionSelected: "A",
      classSelected: "Class 6"
    },
    {
      id: 12,
      teacherName: "Dipak",
      subjectName: "Science",
      sectionSelected: "B",
      classSelected: "Class 6"
    },
    {
      id: 13,
      teacherName: "Ravi",
      subjectName: "Biology",
      sectionSelected: "A",
      classSelected: "Class 6"
    },
    {
      id: 14,
      teacherName: "Yogesh",
      subjectName: "Social",
      sectionSelected: "C",
      classSelected: "Class 6"
    },
    {
      id: 15,
      teacherName: "Aman",
      subjectName: "English",
      sectionSelected: "A",
      classSelected: "Class 7"
    },
    {
      id: 16,
      teacherName: "Akash",
      subjectName: "Science",
      sectionSelected: "B",
      classSelected: "Class 7"
    },
    {
      id: 17,
      teacherName: "Rehan",
      subjectName: "Science",
      sectionSelected: "C",
      classSelected: "Class 7"
    },
    {
      id: 18,
      teacherName: "Rohan",
      subjectName: "EVS",
      sectionSelected: "A",
      classSelected: "Class 8"
    },
    {
      id: 19,
      teacherName: "Rohit",
      subjectName: "English",
      sectionSelected: "B",
      classSelected: "Class 8"
    },
    {
      id: 20,
      teacherName: "Naksh",
      subjectName: "S.Science",
      sectionSelected: "A",
      classSelected: "Class 9"
    },
    {
      id: 21,
      teacherName: "Shreya",
      subjectName: "Maths",
      sectionSelected: "B",
      classSelected: "Class 9"
    },
    {
      id: 22,
      teacherName: "Rakesh",
      subjectName: "Science",
      sectionSelected: "A",
      classSelected: "Class 10"
    },
    {
      id: 23,
      teacherName: "Amit",
      subjectName: "Social",
      sectionSelected: "B",
      classSelected: "Class 10"
    }
  ],
  page: 1,
  temp: [],
  perPage: 5,
  length: 0,
  totalPages: 0,
  isLoaded: false
};

const teachersReducers = (state = initialState, action) => {
  let id = 23;
  switch (action.type) {
    case ADD_TEACHER_SUBJECT:
      id++;
      return {
        ...state,
        teachers: [...state.teachers, { ...action.payload, id: id }]
      };
    case CREATE_PAGES: {
      if (state.temp.length !== 0) {
        return {
          ...state,
          length: state.temp.length,
          totalPages: state.temp.length / state.perPage,
          isLoaded: true
        };
      } else {
        return {
          ...state,
          length: state.teachers.length,
          totalPages: state.teachers.length / state.perPage,
          isLoaded: true
        };
      }
    }
    case ADD_CLASS_SECTION:
      let arr = state.classes;
      let data = action.payload;
      let sectionAdded = false;

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].std == data.std) {
          arr[i].sections.push(data.section);
          sectionAdded = true;
        }
      }
      if (sectionAdded == false) {
        arr.push({ std: data.std, sections: [data.section] });
      }

      return {
        ...state,
        classes: [...state.classes]
      };
    case FILTER_TEACHERS:
      let arr1 = state.teachers;
      let tempData = [];
      console.log(action.payload);
      if (action.payload == "all") {
        tempData = [...arr1];
      } else {
        tempData = arr1.filter(ele => {
          return ele.classSelected == action.payload;
        });
      }
      return {
        ...state,
        temp: [...tempData]
      };
    case DELETE_DATA:
      let arr2 = state.teachers;
      let updatedData = arr2.filter(ele => {
        return ele.id !== action.payload;
      });
      return {
        ...state,
        teachers: [...updatedData],
        temp: [...updatedData]
      };
    case EDIT_TEACHERS_DATA:
      let arr3 = state.teachers;
      let editedData = arr3.filter(ele => {
        return ele.id !== action.payload.id;
      });
      let editedData2 = [...editedData, action.payload];
      editedData2.sort((a, b) => a.id - b.id);
      return {
        ...state,
        teachers: [...editedData2]
      };
    case CHANGE_PAGE_NO:
      return {
        ...state,
        page: action.payload
      };
    default: {
      return state;
    }
  }
};

export default teachersReducers;
